/**
 * Checks the error type from API.
 *
 * @param apiErrorTypes type of error returned by API.
 * @param status status code returned by API.
 *
 */
export function getErrorType(apiErrorTypes, status: number) {
  const errorTypes = {
    400: apiErrorTypes.BadRequestError,
    404: apiErrorTypes.NotFoundError,
    409: apiErrorTypes.DuplicateNameError,
    422: apiErrorTypes.LabelValidationError,
  };

  const errorType = errorTypes[status];
  return errorType ? errorType : apiErrorTypes.ServiceUnavailableError;
}
